<template>
  <v-card class="mx-4 my-6" :style="cardClass" id="network-health-notification">
    <v-card-title class="pr-0" style="word-break: normal">
      <v-card-text
        class="
        text-h6
        font-weight-medium
        text-uppercase
        pa-0
      "
      >
        Network Health Notification
      </v-card-text>
    </v-card-title>
    <v-row>
      <v-col class="mx-4">
        <v-text-field
          filled
          dense
          type="number"
          v-model="offline_duration"
          id="offline-duration"
          label="Offline Duration (days)"
        />
        <v-text-field
          filled
          dense
          type="number"
          v-model="notification_frequency"
          id="notification-frequency"
          label="Notification Frequency (days)"
        />
        <v-select
          filled
          v-model="selected_emails"
          :items="users"
          multiple
          id="select-users"
          label="Select Users"
          dense
        />
        <v-combobox
          multiple
          v-model="additional_emails"
          filled
          label="Additional Emails"
          id="additional-emails"
          :delimiters="[',', ' ']"
          dense
          height="120"
          append-icon
          chips
          deletable-chips
          @change="delimit"
        />
        <v-row align="center">
          <v-col>
            <v-card-text class="text-subtitle-1 px-2 py-0" id="offline-reports">
              Send offline screen reports
            </v-card-text>
          </v-col>
          <v-col cols="3" class="d-flex justify-end mr-3 px-0">
            <v-checkbox
              v-model="send_offline_report"
              id="offline-reports-checkbox"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import GroupDetailData from '@/mixins/GroupDetailData';
import { MobileView } from '@/mixins';

export default {
  mixins: [GroupDetailData, MobileView],
  computed: {
    ...mapGetters({
      _users: 'account/getAllUsers',
    }),
    cardClass() {
      if (this.showMobileView) {
        return '';
      }
      return 'width:30%; overflow:hidden;';
    },
    emails: {
      get() {
        const emails = {
          selected: [],
          additional: [],
        };
        if (
          this.details.tablet_settings
          && this.details.tablet_settings.notification_emails
          && typeof this.details.tablet_settings.notification_emails !== 'string'
        ) {
          this.details.tablet_settings.notification_emails.map((email) => {
            if (
              this.users.find(({ value }) => value === email)
            ) {
              emails.selected.push(
                this.users.find(({ value }) => value === email),
              );
            } else {
              emails.additional.push(email);
            }
          });
        }
        return emails;
      },
      set(obj) {
        this.details.tablet_settings.notification_emails = obj.selected.concat(
          obj.additional,
        );
      },
    },
    selected_emails: {
      get() {
        return this.emails.selected;
      },
      set(array) {
        this.emails = {
          selected: array,
          additional: this.additional_emails,
        };
      },
    },
    additional_emails: {
      get() {
        return this.emails.additional;
      },
      set(array) {
        const selected = [];
        this.selected_emails.map(({ value }) => {
          selected.push(value);
        });
        this.emails = {
          selected,
          additional: array,
        };
      },
    },
    notification_frequency: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.notification_frequency
          : '';
      },
      set(val) {
        this.details.tablet_settings.notification_frequency = Number(val);
      },
    },
    offline_duration: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.offline_duration
          : '';
      },
      set(val) {
        this.details.tablet_settings.offline_duration = val;
      },
    },
    users() {
      const users = [];
      this._users.map((user) => {
        users.push({
          text: user.contact ? user.contact.contact_name : user.email,
          value: user.email,
        });
      });
      return users;
    },
    notification_emails: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.notification_emails
          : '';
      },
      set(val) {
        this.details.tablet_settings.notification_emails = val;
      },
    },
    send_offline_report: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.send_offline_report
          : false;
      },
      set(val) {
        this.details.tablet_settings.send_offline_report = val;
      },
    },
  },
  methods: {
    ...mapActions({
      _getAllUsers: 'account/getAllUsers',
    }),
    delimit(v) {
      const reducer = (a, e) => [...a, ...e.split(/[, ]+/)];
      this.additional_emails = [...new Set(v.reduce(reducer, []))];
    },
  },
  mounted() {
    this._getAllUsers();
  },
};
</script>
